<template>
	<s-modal-bottom-sheet v-model="show">
		<template #activator="{ on }">
			<v-btn
				class="ml-2"
				text
				small
				rounded
				outlined
				v-on="on"
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>
		</template>

		<v-sheet
			class="pa-3"
			outlined
		>
			<v-form @submit.stop.prevent="submit">
				<v-combobox
					v-if="!isCreatingNew"
					ref="nameCombobox"
					v-model="form.display_name"
					:search-input.sync="autocompletes.tag.term"
					:items="autocompletes.tag.items"
					:return-object="false"
					item-text="display_name"
					item-value="display_name"
					autocomplete="off"
					label="Тег"
					outlined
					dense
				>
					<template #no-data>
						<v-list-item @click="switchCreatingNew">
							<span class="subheading mr-2">Создать тег</span>
							<v-chip
								label
								small
							>
								{{ autocompletes.tag.term }}34234
							</v-chip>
						</v-list-item>
					</template>
					<template #item="{ item, attrs, on }">
						<v-chip
							:color="item.color"
							v-bind="attrs"
							v-on="on"
						>
							{{ item.display_name }}
						</v-chip>
					</template>
				</v-combobox>
				<v-text-field
					v-else
					v-model="form.display_name"
					label="Тег"
					outlined
					dense
					clearable
					@click:clear="switchCreatingNew"
				/>

				<v-select
					ref="colorSelect"
					v-if="isCreatingNew"
					v-model="form.color"
					:items="colors"
					label="Цвет"
					outlined
					dense
				>
					<template #item="{ item, attrs, on }">
						<v-chip
							:color="item"
							v-bind="attrs"
							v-on="on"
						>
							{{ item }}
						</v-chip>
					</template>
				</v-select>

				<v-btn
					type="submit"
					outlined
				>
					Сохранить
				</v-btn>
			</v-form>
		</v-sheet>
	</s-modal-bottom-sheet>
</template>

<script>
import axios from 'axios';
import SModalBottomSheet from '@/components/base/s-modal-bottom-sheet';

const EMPTY_FORM = () => ({
	display_name: '',
	color: null,
});

export default {
	name: 'RepairOrdersTagCreate',
	components: { SModalBottomSheet },
	props: {
		orderId: {
			type: Number,
			required: true,
		},
	},
	data: () => ({
		show: false,
		form: EMPTY_FORM(),
		isCreatingNew: false,
		autocompletes: {
			tag: {
				term: '',
				items: [],
			},
		},
		colors: [
			'blue',
			'orange',
			'red',
			'green',
			'yellow',
			'purple',
			'cyan',
			'pink',
			'indigo',
			'teal',
			'lime',
			'blue-grey',
			'brown',
		],
	}),
	watch: {
		'autocompletes.tag.term'(val) {
			this.searchTags(val);
		},
	},
	mounted() {
		this.CancelToken = axios.CancelToken;
		this.source = this.CancelToken.source();
	},
	methods: {
		async searchTags(term) {
			try {
				this.source.cancel('Operation cancelled by user');
				this.source = this.CancelToken.source();
				const response = await this.$http.get('/api/v1/tags', {
					params: {
						filters: {
							search: term,
						},
					},
					cancelToken: this.source.token,
				});
				this.autocompletes.tag.items = response.data.data;
			} catch (e) {
				console.error(typeof e, e);
			}
		},
		async submit() {
			try {
				const response = await this.$http.patch(`/api/v2/service/orders/repair/${this.orderId}`, {
					tags: {
						add: [ this.form ],
					},
				});
				this.$emit('created', response.data.data.tags);
				this.$notify('Тег добавлен');
				this.show = false;
				this.form = EMPTY_FORM();
				this.isCreatingNew = false;
			} catch (e) {
				this.$notify.error(e.message);
			}
		},
		switchCreatingNew() {
			if (this.isCreatingNew) {
				this.form = EMPTY_FORM();
				this.isCreatingNew = false;
			} else {
				this.form.display_name = this.autocompletes.tag.term;
				this.isCreatingNew = true;
			}
		},
	},
};
</script>

<style scoped>

</style>
